import styled from 'styled-components';
import { colourPalette } from 'styles/styles';
export const LoginSSOProvidersStyle = {
  Container: styled.div``,
  InnerContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,
  Title: styled.h4`
    margin: 0;
    font-weight: 400;
    font-size: 24px;
    line-height: 18px;
    color: ${colourPalette.neutral900};
    margin-bottom: 32px;
  `,
};
